const name = 'HeaderFadeOut';
const properties = {
    schema: {
        duration: {
            type: 'number',
            min: 0,
            default: 0,
        },
        delay: {
            type: 'number',
            min: 0,
            default: 0,
        },
    },
};
function animate(kit, elements, duration, delay, params) {
    const sequence = kit.sequence(params);
    const animationParams = {
        ease: 'Quart.easeIn',
        to: { autoAlpha: 0 },
    };
    sequence.add(kit.animate('BaseFade', elements, duration, delay, animationParams));
    return sequence.get();
}
export { name, properties, animate };
//# sourceMappingURL=HeaderFadeOut.js.map